module.exports = __webpack_public_path__ + "img/talks_1.f7f38a18.png";